module.exports = __webpack_public_path__ + "img/img_mainland_account_open_1.1e0ad948.png";